export const EVENT_LABELS: Record<string, string> = {
  PROJECTED_RETREAT_CREATED: "Projected retreat created",
  RETREAT_SUB_ADMIN_ASSIGNED: "Retreat sub-admin assigned",
  RETREAT_SUB_ADMIN_REMOVED: "Retreat sub-admin removed",
  LEAD_COUPLE_ASSIGNED: "Lead couple assigned",
  LEAD_COUPLE_CHANGED: "Lead couple changed",
  LEAD_COUPLE_REMOVED: "Lead couple removed",
  CO_LEAD_COUPLE_ASSIGNED: "Co-lead couple assigned",
  CO_LEAD_COUPLE_CHANGED: "Co-lead couple changed",
  CO_LEAD_COUPLE_REMOVED: "Co-lead couple removed",
  MENTOR_COUPLE_ASSIGNED: "Mentor couple assigned",
  MENTOR_COUPLE_CHANGED: "Mentor couple changed",
  MENTOR_COUPLE_REMOVED: "Mentor couple removed",
  COMMITTEE_MEMBER_ASSIGNED: "Committee member assigned",
  COMMITTEE_MEMBER_REMOVED: "Committee member removed",
  LEAD_COUPLE_ACCESS_GRANTED: "Lead couple access granted",
  LEAD_COUPLE_ACCESS_CHANGED: "Lead couple access changed",
  LEAD_COUPLE_ACCESS_REMOVED: "Lead couple access removed",
  RETREAT_SETUP_STARTED: "Retreat setup started",
  STATUS_CHANGED: "Status changed",
  NOTIFICATION_SENT: "Notification sent",
  PUBLICATION_APPROVED: "Publication approved",
  PUBLICATION_CHANGES_REQUESTED: "Publication changes requested",
  POST_RETREAT_CLOSING_APPROVED: "Post-retreat closing approved",
  RETREAT_CLOSED: "Retreat closed",
  RETREAT_DELETED: "Retreat deleted",
  RETREAT_RESTORED: "Retreat restored",
  READY_FOR_APPROVAL: "Ready for approval",
  USER_LOGIN: "Logged in",
  USER_LOGOUT: "Logged out",
  COUPLE_REGISTERED: "Couple registered",
};
